import { FirearmResolverBase } from './firearm.resolver.base';
import { FirearmService } from './firearm.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmResolver extends FirearmResolverBase {

  constructor(protected service: FirearmService) {
    super(service);
  }
}



